export default {
  methods: {
    $handleError: function(error, defaultMessage, title) {

      let data = {
        title: title || 'Error',
        dangerouslyUseHTMLString: true,
        duration: 10000,
        message: defaultMessage || 'Unexpected Error',
      };

      try {
        let response = error.response;
        const status = response.status;

        if (status === 422) {
          data.title = response.data.message;

          let errors = '';
          Object.keys(response.data.errors).forEach(item => {
            let field = response.data.errors[item];
            for (let i = 0; i < field.length; i++) {
              errors += field[i] + '<br />';
            }
          });

          data.message = errors;

          this.$setValidationErrorsFromResponse(response.data);
        } else if (response.data.message) {
          data.message = response.data.message;
        }

        if (status >= 500) {
          data.message = 'Internal server error';
        }

        if (status === 401) {
          data.message = response.data.message || 'Access Denied';
        }

        if (status === 419) {
          data.message = 'Session expired. Please reload the page and try again.';
        }

        if (status === 429) {
          data.message = 'Too many attempts. Please try again later.';
        }

        if (status === 403) {
          data.message = 'Access Denied';
        }
      } catch (ex) {
        console.warn(ex);
      }

      this.$alert(data.message, data.title, {
        confirmButtonText: 'Close',
        type: 'error',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'el-button--danger',
      });
    },
    $getValidationErrors: function(response) {
      let message = '';
      // Loop through each error message and add it to our message variable
      Object.keys(response.data).forEach(item => {
        let field = response.data[item];
        for (let i = 0; i < field.length; i++) {
          message += field[i];
        }
      });

      return message;
    },
    $setValidationErrorsFromResponse(data) {
      if (!this.hasOwnProperty('$validator')) {
        return;
      }

      this.$validator.errors.clear();

      // check if errors exist
      if (!data.hasOwnProperty('errors')) {
        return;
      }

      const errorFields = Object.keys(data.errors);

      for (let i = 0; i < errorFields.length; i++) {
        const field = errorFields[i];

        const errorString = data.errors[field].join(', ');
        this.$validator.errors.add({field: field, msg: errorString});
      }
    },
  },
};
